import { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Panel, Pill } from "@/components/Bits";
import { toast } from "sonner";
import { useAuth } from "@/contexts/AuthContext";

const STATUSES = ["present", "absent", "sick", "leave"];

export default function Attendance() {
  const { user } = useAuth();
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [students, setStudents] = useState([]);
  const [att, setAtt] = useState({});

  const load = async () => {
    const [s, a] = await Promise.all([api.get("/students"), api.get(`/attendance?date=${date}`)]);
    setStudents(s.data);
    const map = {};
    a.data.forEach(x => { map[x.student_id] = x.status; });
    setAtt(map);
  };
  useEffect(() => { load(); }, [date]);

  const mark = async (student_id, status) => {
    setAtt(prev => ({ ...prev, [student_id]: status }));
    try {
      await api.post("/attendance", { date, student_id, status });
      toast.success("Marked", { duration: 1500 });
    } catch { toast.error("Could not save"); }
  };

  const counts = STATUSES.reduce((m, s) => { m[s] = Object.values(att).filter(v => v === s).length; return m; }, {});

  return (
    <div>
      <PageHeader eyebrow="Attendance" title="Mark today's attendance" subtitle="A tap each. Done in a minute." />

      <div className="flex flex-wrap items-center gap-3 mb-6">
        <input type="date" value={date} onChange={e=>setDate(e.target.value)} className="h-11 px-3 rounded-xl border border-border bg-white" data-testid="att-date" />
        {STATUSES.map(s => (
          <Pill key={s} tone={s === "present" ? "sage" : s === "absent" ? "danger" : s === "sick" ? "mustard" : "lavender"}>{s}: {counts[s] || 0}</Pill>
        ))}
      </div>

      <Panel testid="attendance-list">
        <div className="grid sm:grid-cols-2 gap-3">
          {students.map(s => (
            <div key={s.student_id} className="flex items-center justify-between p-3 rounded-2xl border border-border" data-testid={`att-row-${s.student_id}`}>
              <div>
                <div className="font-semibold text-sm">{s.name}</div>
                <div className="text-xs text-ink-soft">{s.class_name}</div>
              </div>
              <div className="flex gap-1">
                {STATUSES.map(st => (
                  <button
                    key={st}
                    onClick={() => mark(s.student_id, st)}
                    className={`w-9 h-9 rounded-xl text-xs font-bold uppercase ${att[s.student_id] === st ? (st === "present" ? "bg-sage-deep text-white" : st === "absent" ? "bg-red-500 text-white" : st === "sick" ? "bg-mustard text-ink" : "bg-lavender-deep text-white") : "bg-paper-alt text-ink-soft hover:bg-paper"}`}
                    title={st}
                    data-testid={`att-btn-${s.student_id}-${st}`}
                  >
                    {st[0].toUpperCase()}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      </Panel>
    </div>
  );
}
